<template>
  <div
    v-if="personData"
    :class="
      `team-member-profile ${isOpen ? 'team-member-profile--visible' : ''}`
    "
  >
    <div class="team-member-profile__close">
      <button aria-label="Close profile information" @click="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.456"
          height="25.456"
          viewBox="0 0 25.456 25.456"
        >
          <g
            id="Group_115"
            data-name="Group 115"
            transform="translate(-3.272 0.728)"
          >
            <path
              id="Path_787"
              data-name="Path 787"
              d="M0,0H32"
              transform="translate(4.686 0.686) rotate(45)"
              fill="#435bdb"
              stroke="#fff"
              stroke-width="4"
            />
            <path
              id="Path_788"
              data-name="Path 788"
              d="M0,0H32"
              transform="translate(4.686 23.314) rotate(-45)"
              fill="#435bdb"
              stroke="#fff"
              stroke-width="4"
            />
          </g>
        </svg>
      </button>
    </div>
    <div class="team-member-profile__content row">
      <div class="team-member-profile__details col-12 col-lg-7">
        <p class="team-member-profile__details__name">
          {{ person.first_name }} {{ person.last_name }}
        </p>
        <p class="team-member-profile__details__title">{{ person.title }}</p>
        <div class="team-member-profile__details__contact">
          <a
            v-if="person.email_address"
            :href="`mailto:${person.email_address}`"
            :title="`Email ${person.first_name} ${person.last_name}`"
          >
            {{ person.email_address }}
          </a>
          <a
            v-if="person.phone_number"
            :href="`tel:${person.phone_number}`"
            :title="`Call ${person.first_name} ${person.last_name}`"
          >
            {{ person.phone_number }}
          </a>
          <a
            v-if="person.mobile_number"
            :href="`tel:${person.mobile_number}`"
            :title="`Call ${person.first_name} ${person.last_name}`"
          >
            {{ person.mobile_number }}
          </a>
          <a
            v-if="person.linkedin_url"
            :href="`${person.linkedin_url}`"
            :title="
              `View ${person.first_name} ${person.last_name}'s LinkedIn Prfile`
            "
            target="_blank"
            rel="noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.521"
              height="22.521"
              viewBox="0 0 22.521 22.521"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M5.027,5.021H.352V-10.01H5.027ZM2.715-12.071a2.61,2.61,0,0,1-1.91-.8,2.61,2.61,0,0,1-.8-1.91A2.61,2.61,0,0,1,.8-16.7a2.61,2.61,0,0,1,1.91-.8,2.61,2.61,0,0,1,1.91.8,2.61,2.61,0,0,1,.8,1.91,2.61,2.61,0,0,1-.8,1.91A2.61,2.61,0,0,1,2.715-12.071ZM22.521,5.021H17.846V-2.318a8.12,8.12,0,0,0-.3-2.614A2.116,2.116,0,0,0,15.383-6.29a2.355,2.355,0,0,0-2.262,1.206,5.612,5.612,0,0,0-.5,2.664v7.44H7.993V-10.01h4.474v2.061h.05a4.017,4.017,0,0,1,1.609-1.659,4.956,4.956,0,0,1,2.815-.8q3.268,0,4.575,2.061a10.167,10.167,0,0,1,1.005,5.128Z"
                transform="translate(0 17.5)"
                fill="#fff"
              />
            </svg>
          </a>
        </div>
        <div
          class="team-member-profile__details__bio"
          v-html="person.biography"
        />
      </div>
      <div
        class="team-member-profile__quote col-12 col-lg-5"
        v-if="person.quote_content"
      >
        <blockquote v-html="person.quote_content" />
        <figcaption class="team-member-profile__quote__attributee">
          {{ person.quote_person_name }}
          <br />
          <span class="team-member-profile__quote__attributee__title">
            {{ person.quote_person_subtitle }}
          </span>
        </figcaption>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMemberProfile",
  data() {
    return {
      personData: null,
      isOpen: false
    };
  },
  props: {
    person: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    close() {
      // this.personData = null
      this.$emit('closed')
      this.isOpen = false;
    }
  },
  mounted() {
    this.personData = this.person;
    this.isOpen = true;
  },
  watch: {
    // Update the person data when the prop changes
    person: function(val) {
      this.personData = val;
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.team-member-profile {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;

  &--visible {
    max-height: 100%;

    @include media-breakpoint-down(md) {
      max-height: 2000px;
    }
  }

  &__close {
    padding-right: 15px;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @include media-breakpoint-down(md) {
      padding-right: 0;
    }

    button {
      border: 0;
      background-color: transparent;
      padding: 29px;

      @include media-breakpoint-down(md) {
        padding: 15px;
      }

      path {
        transition: stroke 0.3s ease-in-out;
      }

      &:focus,
      &:hover {
        path {
          stroke: #88e8e3;
        }
      }
    }
  }

  &__quote {
    position: relative;
    padding: 120px 80px 80px;
    color: white;

    @include media-breakpoint-down(md) {
      margin-top: 20px;
      padding: 65px 50px;
    }

    blockquote {
      @include fslh(24, 28);
      font-weight: $font-weight-light;

      @include media-breakpoint-down(md) {
        @include fslh(19, 24);
      }
    }

    &:before,
    &:after {
      content: "";
      display: block;
      width: 80px;
      height: 120px;
      position: absolute;
      background: {
        position: center;
        size: contain;
        repeat: no-repeat;
      }

      @include media-breakpoint-down(md) {
        width: 40px;
        height: 60px;
      }
    }

    &:before {
      top: 0;
      left: 0;
      background: {
        image: url("/app/themes/lava-advisory-partners/images/testimonial-top-left.svg");
      }
    }

    &:after {
      bottom: 0;
      right: 0;
      transform: rotate(180deg) scaleX(-1);
      background: {
        image: url("/app/themes/lava-advisory-partners/images/testimonial-bottom-right.svg");
      }
    }

    &__quote {
      color: #124968;
      justify-content: space-around;

      p {
        @include fslh(24, 30);
        font-weight: $font-weight-light;
      }

      @include media-breakpoint-down(md) {
        height: auto;
      }
    }

    &__attributee {
      @include fslh(16, 22);
      font-weight: $font-weight-bold;
      margin-top: 19px;
      color: white;

      &__title {
        font-weight: $font-weight-lighter;
        display: block;
      }
    }
  }

  &__content {
  }

  &__details {
    padding: 0 15px 80px 0;
    color: white;

    @include media-breakpoint-down(md) {
      padding: 0 50px 0 40px;
    }

    &__name {
      @include fslh(42, 48);
      font-weight: $font-weight-light;
      margin-bottom: 0;
    }

    &__title {
      @include fslh(24, 28);
      font-weight: $font-weight-light;
      margin-bottom: 16px;
    }

    &__contact {
      a {
        display: block;
        text-decoration: none;
        @include fslh(20, 24);
        margin-bottom: 8px;

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }
    }

    &__linkedin {
      width: 24px;
      height: 24px;
    }

    &__bio {
      margin-top: 34px;
      @include fslh(16, 22);
    }
  }
}
</style>
